import { render, staticRenderFns } from "./address-add.vue?vue&type=template&id=0a7d8d22&scoped=true&"
import script from "./address-add.vue?vue&type=script&lang=js&"
export * from "./address-add.vue?vue&type=script&lang=js&"
import style0 from "./address-add.vue?vue&type=style&index=0&id=0a7d8d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d8d22",
  null
  
)

export default component.exports